import {Component, OnInit} from '@angular/core';
import {SideNavComponent, TopNavComponent} from '../../ui';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.css'],
    providers: [SideNavComponent, TopNavComponent]
})
export class MainComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /app/src/app/containers/main/main.component.ts